import { EventTerminal } from './primitives/EventTerminal';
import {
  type EventHandler,
  TelemetryServiceEvent,
  type TelemetryServiceEventDetails,
  TelemetryServiceOutgoingEvent,
  type TelemetryServiceOutgoingEventDetails,
} from './types/events';
import type { Metadata } from './types/meta';
import type { TelemetryReportData, TransmissionOptions } from './types/report';

export class TelemetryClient {
  private terminal: EventTerminal<
    typeof TelemetryServiceOutgoingEvent,
    TelemetryServiceOutgoingEventDetails,
    typeof TelemetryServiceEvent,
    TelemetryServiceEventDetails
  >;

  constructor() {
    this.terminal = new EventTerminal<
      typeof TelemetryServiceOutgoingEvent,
      TelemetryServiceOutgoingEventDetails,
      typeof TelemetryServiceEvent,
      TelemetryServiceEventDetails
    >(TelemetryServiceOutgoingEvent);
  }

  report(reportData: Partial<TelemetryReportData>, options?: TransmissionOptions): void {
    this.terminal.emit(TelemetryServiceEvent.Report, { data: reportData, options });
  }

  reportText(text: string, options?: TransmissionOptions): void {
    this.terminal.emit(TelemetryServiceEvent.ReportText, { data: text, options });
  }

  updateMeta(meta: Partial<Metadata>): void {
    this.terminal.emit(TelemetryServiceEvent.UpdateMeta, { meta });
  }

  addEventListener<Name extends TelemetryServiceOutgoingEvent>(
    eventName: Name,
    handler: EventHandler<TelemetryServiceOutgoingEventDetails[Name]>
  ): void {
    this.terminal.addEventListener(eventName, handler);
  }

  removeEventListener<Name extends TelemetryServiceOutgoingEvent>(
    eventName: Name,
    handler: EventHandler<TelemetryServiceOutgoingEventDetails[Name]>
  ): void {
    this.terminal.removeEventListener(eventName, handler);
  }
}
